import {BaseUnit} from '../models/unit-tracking/base-unit.model';

export class UnitsResponse {
  data: BaseUnit[];
  total: number;
  count: number;
  page: number;
  pageCount: number;
}
